<template>
  <QDialog v-model="show" transition-show="scale" transition-hide="scale">
    <QCard class="calculator-dialog-card" :style="qCardStyle">
      <QCardActions class="calculator-dialog-header-action column items-end">
        <QBtn style="text-transform: none" flat rounded :icon-right="closeIcon" color="grey-8" v-close-popup>Close</QBtn>
      </QCardActions>
      <div :style="htmlStyle" :class="htmlClassName" v-if="html" v-html="html" />
      <QCardSection v-else class="calculator-dialog-content">
        <div class="calculator-dialog-header column justify-center items-center q-pa-lg">
          <QIcon v-if="headerIcon" color="primary" class="q-mb-md" :name="headerIcon" size="4rem" />
          <h3 v-if="header" class="font-baloo text-primary text-center" v-html="header" :style="headerStyle"></h3>
          <h4 v-if="subheader" class="font-nunito text-grey-9 text-center" v-html="subheader"></h4>
        </div>
        <div v-if="body" class="calculator-dialog-body column text-center items-center">
          <div class="font-nunito text-grey-9 text-wrap" v-html="body"></div>
        </div>
        <div v-if="closeFooterLabel" class="calculator-dialog-footer column items-center q-py-xl">
          <CalculatorButton
            style="width: 260px; height: 48px"
            color="primary"
            rounded
            hasChevronIcon
            :label="closeFooterLabel"
            outlined
            v-close-popup
          />
        </div>
      </QCardSection>
    </QCard>
  </QDialog>
</template>

<script>
import { QDialog, QCard, QCardSection, QCardActions, QIcon, QBtn } from 'quasar';
import { ClosePopup } from 'eclipx.ui';
import { evaCloseCircleOutline } from '@quasar/extras/eva-icons';
import CalculatorButton from '@/components/Calculator/CalculatorButton';

export const CalculatorDialog = 'CalculatorDialog';

export default {
  name: 'CalculatorDialog',
  data() {
    return {
      show: false,
      header: '',
      headerStyle: '',
      headerIcon: '',
      html: '',
      htmlStyle: '',
      htmlClassName: '',
      subheader: '',
      body: '',
      closeFooterLabel: '',
      qCardStyle: ''
    };
  },
  computed: {},
  methods: {
    close: async function () {
      this.show = false;
    }
  },
  created() {
    this.closeIcon = evaCloseCircleOutline;
  },
  beforeCreate() {
    this.$euiNotifications.EventBus.$on(CalculatorDialog, (params) => {
      this.$nextTick(function () {
        this.show = true;
        this.header = params.header;
        this.headerIcon = params.headerIcon;
        this.headerStyle = params.headerStyle;
        this.subheader = params.subheader;
        this.qCardStyle = params.qCardStyle;
        this.body = params.body;
        this.html = params.html;
        this.htmlStyle = params.htmlStyle;
        this.closeFooterLabel = params.closeFooterLabel;
        this.htmlClassName = params.htmlClassName;
      });
    });
  },
  directives: {
    ClosePopup
  },
  components: {
    QDialog,
    QCard,
    QCardSection,
    QCardActions,
    QIcon,
    QBtn,
    CalculatorButton
  }
};
</script>

<style lang="sass" scoped>
.calculator-dialog-card
  max-width: 665px
  width: 100%
  min-height: 387px
  display: flex
  flex-flow: column wrap
  .calculator-dialog-header-action
    align-self: end
    width: 100%
  .calculator-dialog-content
    justify-content: space-around
    align-self: center
    max-width: 425px
    display: flex
    flex-flow: column wrap
    .calculator-dialog-header
      text-align: center
      h3
        font-size: 2rem
        font-weight: 700

    .calculator-dialog-body
      text-align: center
</style>
